import { useHistory } from 'react-router-dom';
import { ModalWrap } from '../../../../../components/modal-wrap';
import getFormatMessage from '../../../../../locales/get-format-message';
import { IApiOrderListItem } from '../../../../../model/api-modules';
import { useSelector } from 'react-redux';
import { IRootState } from '../../../../../store/reducers';
import { cancelOrder, confirmOrder } from '../../../../../api';
import { messageError } from '../../../../../components/message';
import styles from './index.module.scss';

interface IProps {
  cashRemain?: number;
  order: IApiOrderListItem;
  onOk: () => void;
  onCancel: () => void;
}

export const OrderPayModal = (props: IProps) => {
  const { order, onOk, onCancel } = props;

  const userInfo = useSelector((state: IRootState) => state.common.userInfo);

  if (!order || !userInfo) {
    return null;
  }

  const submit = async () => {
    const res = await confirmOrder(order.order_id, userInfo.UserID);
    if (!res) {
      messageError(getFormatMessage('order_pay_failed'));
      return false;
    }
    onOk();
    return true;
  };

  return (
    <ModalWrap
      width="660px"
      title={getFormatMessage('order_modal_confirm_title')}
      oKText={getFormatMessage('confirm')}
      cancelText={getFormatMessage('cancel')}
      onOk={submit}
      onClose={onCancel}
    >
      <>
        <span>{getFormatMessage('order_modal_confirm_info')}</span>
        <span style={{ color: '#F77E45' }}>¥ {order.freeze_amount}</span>
        <div className={styles.desc}>
          <span>{getFormatMessage('order_modal_confirm_content_1')}</span>
          <span>{getFormatMessage('order_modal_confirm_content_2')}</span>
          <span>{getFormatMessage('order_modal_confirm_content_3')}</span>
        </div>
      </>
    </ModalWrap>
  );
};

export const OrderCancelModal = (props: IProps) => {
  const { order, onOk, onCancel } = props;
  const submit = async () => {
    const res = await cancelOrder(order.order_id);
    if (!res) {
      messageError(getFormatMessage('order_cancel_failed'));
      return false;
    }
    onOk();
    return true;
  };
  if (!order) {
    return null;
  }

  return (
    <ModalWrap
      title={getFormatMessage('order_modal_cancel_title')}
      oKText={getFormatMessage('confirm')}
      cancelText={getFormatMessage('cancel')}
      onOk={submit}
      onClose={onCancel}
    >
      <div className={styles.cancelContent}>
        <div className={styles.cancelContentItem}>
          <label>{getFormatMessage('order_id')}</label>
          <span>{order.order_id}</span>
        </div>
        <div className={styles.cancelContentItem}>
          <label>{getFormatMessage('order_produce_service')}</label>
          <span>{order.service_name}</span>
        </div>

        <div className={styles.cancelContentItem}>
          <label>{getFormatMessage('order_need_amount')} (¥)</label>
          <span style={{ color: '#F77E45' }}>{order.freeze_amount}</span>
        </div>
      </div>
    </ModalWrap>
  );
};

export const CashLackModal = (props: IProps) => {
  const { cashRemain = 0, order, onOk, onCancel } = props;

  const selectStudio = useSelector(
    (state: IRootState) => state.studio.selectStudio
  );
  const history = useHistory();

  const submit = async () => {
    history.push(`/studio/${selectStudio?.studioID}/fee/overview/recharge`);
    onOk();
    return true;
  };
  if (!order) {
    return null;
  }

  return (
    <ModalWrap
      title={getFormatMessage('order_modal_lack_title')}
      oKText={getFormatMessage('order_go_to_recharge')}
      cancelText={getFormatMessage('order_cancel_service')}
      onOk={submit}
      onClose={onCancel}
    >
      <div>
        <div>
          <label>{getFormatMessage('account_balance')} (¥) </label>
          <span>{cashRemain}</span>
        </div>
        <div>
          <label>{getFormatMessage('order_need_amount')} (¥)</label>
          <span>{order.freeze_amount}</span>
        </div>
      </div>
    </ModalWrap>
  );
};
